import _ from 'lodash';
import Tasks from '../../controllers/tasks';
import Filter from '../../controllers/filter';
import Baselines from '../../baselines';

export default instance => {
  instance.attachEvent('onParse', _.once(() => Tasks.addButtonsToProjectTasks()));
  instance.attachEvent('onParse', () => {
    if (instance._ganttPreventFilter) {
      instance._ganttPreventFilter = false;

      return;
    }
    Filter.onParse();
  });
  instance.attachEvent('onParse', () => Baselines.checkUserEnabledBaselines());
  // instance.attachEvent('onParse', _.once(() => instance.scrollTo(instance.posFromDate(new Date()) - 50, null)));
};
